import classNames from "classnames";
import _ from "lodash";
import {  useState } from "react";
import { useWindowSize } from "react-use";
import { useDeviceClassification } from "utils";
import styles from "./SubpageHeader.module.css";

export interface SubpageHeaderProps {
  className?: string;
  children: React.ReactNode;
  color?: string | undefined;
  columnWidth?: number;
  ref?: any;
  style?: {};
}

/**
 * Used on project showcase page. It's a 90% opaque black background. Children
 * should be a span for meta information (address), and an h1 for the heading
 */

export const SubpageHeader = ({
  children,
  className = "",
  color = "rgba(55, 58, 54, 0.9)",
  columnWidth = 5,
  ...props
}: SubpageHeaderProps) => {
 const { isDesktop } = useDeviceClassification();
  /* Desktop > 800px window width | Mobile < 800px  window width */
  /*  
  Usecase: client resizes browser window, we need the left offset of hero block to re-adjust.
  */


  return (
      <header
        id="header"
        style={{
          maxWidth: 'unset',
          background: color,
          width: !isDesktop ? '100%' : `calc((100% / 12 * ${columnWidth}) + (40px / 12 * ${columnWidth} - 40px))`,
          transform: 'translate()'
        }}
        className={classNames(styles.opaqueheader, className)}
        {...props}
      >
        {children}
      </header>
  );
};
